/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import ServiceChannelService from '../service';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';
import { useSelector } from 'react-redux';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import ServiceChannelForm from '../form';
import Pagination from 'components/Pagination';
import ModalConfirmation from '../../../components/Modal/ConfirmationModal';

import {
  Container,
  Row,
  Card,
  CardHeader,
  Button,
  Input,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';

import {
  icon_column_style,
  individual_column_style,
  individual_icon_header_style,
  individual_header_style
} from '../../../assets/styles/table_custom_style';
import ReactLoader from 'components/Loader';

const ServiceChannelList = () => {
  const [serviceChannels, setServiceChannels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [idResource, setidResource] = useState();
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [openFormModal, setOpenFormModal] = useState(false);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    getServiceChannel();
  }, []);

  const getServiceChannel = (selectedPage = 1, query = '') => {
    ServiceChannelService.getWithoutPagination().then((res) => {
      console.log(res);
    });
    ServiceChannelService.getPagination({ page: selectedPage, search: query })
      .then((res) => {
        const serviceChannels = res.data.rows;
        const quantity = res.data.count;
        const newActivePage = selectedPage || activePage;
        setServiceChannels(serviceChannels);
        setQuantity(quantity);
        setActivePage(newActivePage);
        setLoading(false);
      })
      .catch((error) => {
        const { data } = error.response;
        toast.error(data.message || 'Erro ao listar motivos!', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const handlePageChange = (activePage) => getServiceChannel(activePage);

  const deleteServiceChannel = (id) => {
    ServiceChannelService.delete(id)
      .then((res) => {
        const { data } = res;
        getServiceChannel();
        toast.success(data.message, {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .catch((error) => {
        const { data } = error.response;
        toast.error(data.message || 'Erro ao deletar canal de atendimento!', {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .finally(() => {
        setOpenModalConfirmation(false);
        getServiceChannel();
      });
  };

  const controlDelete = (id) => {
    setidResource(id);
    setOpenModalConfirmation(true);
  };

  const handleOnSearch = (event) => {
    const q = event.target.value;
    setTimeout(() => {
      getServiceChannel(1, q);
    }, 500);
  };

  const history = useHistory();
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  const Header = () => (
    <div
      className="header header-dark pb-6 content__title content__title--calendar"
      style={{ background: systemConfiguration.primary_color }}
    >
      <Container fluid>
        <div className="header-body">
          <Row className="align-items-center py-4">
            <Col lg="6" xs="7">
              <Button
                size="sm"
                color={systemConfiguration.primary_color}
                title={'Volta para a pagina de configurações'}
                onClick={() => history.push(`/admin/configuration`)}
              >
                <BiArrowBack size="35px" color="white" />
              </Button>
            </Col>
            <Col className="mt-3 mt-md-0 text-md-right" lg="6" xs="5">
              <Button
                onClick={() => {
                  setEditingId(null);
                  setOpenFormModal(true);
                }}
              >
                Criar
              </Button>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );

  return (
    <>
      <Header />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Canais de Atendimento</h3>
                </CardHeader>
                <Row className="mt-3 mx-2">
                  <Col md="8">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Busca canal de atendimento por nome"
                        type="text"
                        defaultValue=""
                        onChange={handleOnSearch}
                      />
                    </InputGroup>
                  </Col>
                </Row>

                <ToolkitProvider
                  data={serviceChannels}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'name',
                      text: 'Nome',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="info"
                            size="sm"
                            onClick={() => {
                              setEditingId(row.key);
                              setOpenFormModal(true);
                            }}
                          >
                            <li className="fas fa-user-edit"></li>
                          </Button>
                        );
                      }
                    },
                    {
                      dataField: 'delete',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'deletar',
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => controlDelete(row.key)}
                          >
                            <li className="fas fa-trash"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <ServiceChannelForm
                  isModalOpen={openFormModal}
                  onModalToggle={setOpenFormModal}
                  match={{ params: { id: editingId } }}
                  onSaved={() => getServiceChannel(activePage)}
                />
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
      <ModalConfirmation
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={idResource}
        deleteResource={deleteServiceChannel}
        message={'Tem certeza que deseja excluir o canal de atendimento?'}
      />
    </>
  );
};

export default ServiceChannelList;
